<template>
  <div :style="styles.wrap(ready)">
    <nav aria-label="Navigation" :style="styles.nav" class="sidebar-nav" :key="getRouteName">
      <div :style="styles.headerIcons">
        <img :src="getIcon" :style="styles.logo">
        <Avatar
          v-if="ready"
          :username="getUserName"
          :style="styles.headerAvatar"
          color="#ccc"
          backgroundColor="#2b4663"
          :size="40"
        />
      </div>
      <div :style="styles.navItemContainer">
        <router-link
          exact
          :class="{'active-link': navIsActive(link.path)}"
          class="navigationLink"
          v-for="link in links"
          :key="link.name"
          :to="link.path"
          :style="styles.navItem"
        >
          <span :class="link.icon"/>
          <span :style="styles.navTitle">{{link.title}}</span>
        </router-link>
        <div class="settingsLink">
          <p class="navigationLink" @click="goToSettings">
            <span class="glyphicon glyphicon-cog"> </span>&nbsp;
            Settings
          </p>
          <p class="navigationLink" @click="toggleLogoutModal">
            <span class="glyphicon glyphicon-log-out"></span>&nbsp;
            Logout
          </p>
          <span :style="styles.version">v{{ version }}</span>
        </div>
      </div>
    </nav>
    <div :style="styles.contentWrapper(getRouteName === 'media', !!!getActiveMedia, false)" id="scrollWrapper">
      <router-view v-if="!loading"></router-view>
    </div>
  </div>
</template>
<script>
import router from '../../router';
import store from '../../store';
import stateData from '../../store/state';
import ls from 'local-storage';
import Avatar from 'vue-avatar';
import VueNotifications from 'vue-notifications';
import { getResource, postResource } from '../../services/Utils';
import PackageData from '../../../package.json';
import Services from '../../services/Services';
export default {
  name: 'authenticatedSession',
  components: {
    Avatar
  },
  computed: {
    getIcon() {
      return store.getters.getTenant.icon;
    },
    getRouteName() {
      return store.getters.getRoute.name;
    },
    getActiveMedia() {
      return store.getters.getActiveMedia;
    },
    getMarkets() {
      return store.getters.getMarkets;
    },
    getUser() {
      return store.getters.getUser;
    },
    getUserName() {
      const user = this.getUser;
      const p = user.profile.name;
      const name = `${p.first} ${p.last}`;
      return name;
    },
    version() {
      return PackageData.version;
    }
  },
  methods: {
    toggleColdDeckModal() {
      store.commit('showColdDeckModal', true);
    },
    goToSettings() {
      router.push({ name: 'settings' });
    },
    toggleLogoutModal() {
      store.commit('showLogoutModal', true);
    },
    navIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      if(input == this.$route.path) {
          return true;
      } else if(input !== '/media'){
          return paths.some(path => {
            return this.$route.path.indexOf(path) === 0;
        });
      }
    },
    logout(message) {
        console.log('cannot log in because ', message);
      store.commit('hideModals', true);
      ls.set('GEG__KEY', '');
      this.$router.push('/');
      store.commit('setUser', {});
      this.showErrorMsg({ message: message ? message : 'You\'ve been logged out.' })
    },
    validateLogin() {
      return new Promise((resolve, reject) => {
        console.log('validating login...');
        getResource('/v1/auth/check')
          .then(res => {
            if (res.status === 'success') {
              const user = res.user;

              if(user.status !== 'active') {
            //   not an active user
                    console.log('not active user')
                    this.logout('User is inactive.');
                }

                store.commit('setUser', user);
              // update intercom settings
              window.intercomSettings = {
                app_id: "kkkzq24u",
                name: `${user.profile.name.first} ${user.profile.name.last}`,
                email: user.primaryEmail,
                created_at: user.createdAt,
              };
              window.Intercom("boot", {
                app_id: "kkkzq24u"
              });
              return resolve();
            }
          })
          .catch(error => {
            this.logout(error.error)
            return reject(error);
          });
      });
    }
  },
  data() {
    return {
      loading: false,
      ready: false,
      route: store.getters.getRoute.name,
      markets: store.getters.getMarkets,
      links: {
        dashboard: {
          title: 'Dashboard',
          icon: 'glyphicon glyphicon-th-large',
          path: '/dashboard'
        },
        cards: {
          title: 'Action Cards',
          icon: 'glyphicon glyphicon-edit',
          path: '/cards',
          disabled: false
        },
        markets: {
            title: 'Markets',
            icon: 'glyphicon glyphicon-globe',
            path: '/markets'
        },
        media: {
          title: 'Media',
          icon: 'glyphicon glyphicon-film',
          path: '/media'
        },
        mediaLibraries: {
          title: 'Media Libraries',
          icon: 'glyphicon glyphicon-blackboard',
          path: '/media-libraries'
        },
        policies: {
          title: 'Policies',
          icon: 'glyphicon glyphicon-bell',
          path: '/policies'
        },
        products: {
          title: 'Products',
          icon: 'glyphicon glyphicon-tags',
          path: '/products',
          disabled: false
        },
        productGroups: {
            title: 'Product Groups',
            icon: 'glyphicon glyphicon-inbox',
            path: '/product-groups',
            disabled: false
        },
        sequences: {
          title: 'Sequences',
          icon: 'glyphicon glyphicon-tasks',
          path: '/sequences',
          disabled: false
        },
        users: {
          title: 'Users',
          icon: 'glyphicon glyphicon-user',
          path: '/users'
        }
      },
      styles: {
        wrap: ready => ({
          opacity: ready ? '1' : '0',
          transition: 'opacity 1500ms ease-out'
        }),
        wrapper: {
          display: 'flex',
          flexFlow: 'row nowrap'
        },
        logo: {
          width: '60px',
          background: '#fff',
          margin: '10px',
          boxSizing: 'border-box',
          padding: '10px',
          display: 'block',
          borderRadius: '10px',
          border: '1px solid #ddd',
          boxShadow: '0 5px 15px 4px rgba(0,0,0,0.1)',
          height: '60px'
        },
        headerIcons: {
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'flex-start',
          width: '100%',
          justifyContent: 'space-between',
          paddingRight: '10px'
        },
        headerAvatar: {
          marginTop: '10px',
          borderRadius: '10px'
        },
        nav: {
          background: 'linear-gradient()',
          // borderRight: '1px solid #ddd',
          boxSizing: 'border-box',
          height: '100vh',
          position: 'fixed',
          left: '0',
          top: '0',
          bottom: '0',
          padding: '0',
          display: 'flex',
          flexFlow: 'column nowrap',
          width: '200px'
        },
        navItemContainer: {
          display: 'flex',
          flexFlow: 'column nowrap',
          flex: 1
        },
        navItem: {
          display: 'block'
        },
        navTitle: {
          marginLeft: '10px'
        },
        contentWrapper: (media, isActive, dash) => ({
          position: 'fixed',
          left: dash ? 0 : 200,
          right: 0,
          bottom: 0,
          boxShadow: '0 0 40px 10px rgba(0,0,0,0.2)',
          marginRight: 0,
          height: '100vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          width: media
            ? 'calc(100vw - 200px)'
            : dash
            ? '100vw'
            : 'calc(100vw - 200px)'
        }),
        version: {
          fontSize: '0.8em',
          color: '#ccc',
          fontWeight: '400',
          display: 'block',
          padding: '10px 20px 0',
          textAlign: 'right'
        }
      }
    };
  },
  mounted() {
    // check if user is authenticated
    this.validateLogin()
      .then(() => {
        setTimeout(() => {
          this.ready = true;
          const user = store.getters.getUser;
          // check for state reset, revalidate user
          const resetState = user.prefs.resetState;
          if (resetState) {
            // re-apply state
            postResource('/v1/users/reset/state')
              .then(() => {
                store.commit('resetState', () => {
                  // logout user
                  ls.set('GEG__KEY', '');
                  router.push({ name: 'login' });
                });
              })
              .catch(error => console.log(error));
          }
          this.showSuccessMsg({
            message: `Welcome back, ${user.profile.name.first}!`
          });
        }, 1000);
      })
      .catch(error => console.log(error));
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '👋'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  overflow: hidden;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 1.5s ease;
  position: relative;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
  left: 10px;
  opacity: 0;
}

/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: '';
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
<style lang="scss">
@import '../../assets/css/glyphicons.min.css';

.navigationLink {
  font-size: 0.9em;
  // font-family: 'proxima_nova_ltsemibold';
  font-weight: bold !important;
  position: relative;
  display: block;
  padding: 15px 15px 20px;
  color: #ddd;
  // font-weight: 700;
  text-decoration: none;
  transition: all 0.2s;

  &:hover {
    color: #fff;
    background: rgba(0, 0, 0, 0.1);
  }

  &.active-link {
    color: #fff;
    background: rgba(0, 0, 0, 0.2);
  }
}

.sidebar-nav {
  background: linear-gradient(to bottom, rgb(0, 168, 224), rgb(28, 168, 140));
  background: -moz-linear-gradient(
    to bottom,
    rgb(0, 168, 224),
    rgb(28, 168, 140)
  );
  background: -webkit-linear-gradient(
    to bottom,
    rgb(0, 168, 224),
    rgb(28, 168, 140)
  );
}

.settingsLink {
  position: absolute;
  width: 100%;
  bottom: 1rem;
  left: 0;

  p {
    cursor: pointer;
    margin: 0;
  }
}

.glyphicon-log-out {
  transform: rotate(180deg);
}

</style>



// WEBPACK FOOTER //
// src/components/layouts/LoggedIn.vue